import { createContext, useContext } from 'react';
import { ControlPostDetailsModalType } from '@anytag/shared-hooks';
import { CarouselModalProps } from '../../../carousel-modal';

interface ContextType<T extends ControlPostDetailsModalType = ControlPostDetailsModalType> {
  selectedPost?: T | null;
  closeModal?: () => void;
  setModalSize?: (size: CarouselModalProps['size'] | null) => void;
}

export const PostModalContext = createContext<ContextType | null>(null);

export const usePostModalContext = <T extends ControlPostDetailsModalType = ControlPostDetailsModalType>() => {
  const context = useContext(PostModalContext) as ContextType<T> | null;

  if (!context) {
    throw new Error('Post modal components must be used within the Post Modal provider');
  }

  return { ...context, selectedPostId: context.selectedPost?.id };
};
